import {
  CardContainer,
  Container,
  ContentContainer,
  ContentContainerColumn,
  HeadingContainer,
} from 'uikit/layout'
import { Heading } from 'uikit'
import { useHistory, useParams } from 'react-router-dom'
import { Box, Text } from '@chakra-ui/react'
import { Delete, DocumentForm } from './elements'
import { styleType } from '../Documents.constants'
import { useFetchDocument } from './hooks/useFetchDocument'
import { useCreateDocument } from './hooks/useCreateDocument'
import { useUpdateDocument } from './hooks/useUpdateDocument'



export const DocumentsUpdate = () => {
  const { id } = useParams()
  const isNew = !id
  const history = useHistory()
  const { data: item = {}, isFetching: loading } = useFetchDocument(id)
  const { mutate: createDocument, isPending: createLoading } = useCreateDocument()
  const { mutate: updateDocument, isPending: updateLoading } = useUpdateDocument()

  const handleBack = () => {
    history.goBack()
  }

  const getSubmitForm = (list = []) => {
    let names = []
    let bodies = []
    list.forEach((itemDoc) => {
      names.push({
        localization: itemDoc.localization,
        text: itemDoc.name,
        id: itemDoc.idName === 0 ? undefined : itemDoc.idName,
      })
      bodies.push({
        localization: itemDoc.localization,
        text: itemDoc.body,
        id: itemDoc.idBody === 0 ? undefined : itemDoc.idBody,
      })
    })
    return {
      names,
      bodies,
    }
  }

  const handleSubmit = (values) => {
    const dataRequest = {
      ...item,
      needUpdate: values.needUpdate,
      publicAccess: values.publicAccess,
      order: Number(values.order),
      style: values.style !== '' ? values.style : undefined,
      ...getSubmitForm(values.list),
    }

    if (isNew) {
      createDocument(dataRequest, {
        onSuccess: () => {
          handleBack()
        },
      })
    } else {
      updateDocument(
        { id, ...dataRequest },
        {
          onSuccess: () => {
            handleBack()
          },
        }
      )
    }
  }

  return (
    <Container>
      <CardContainer onBack={handleBack} indentTop={70}>
        <ContentContainer>
          <ContentContainerColumn>
            <HeadingContainer justifyContent="flex-start" alignItems="baseline">
              <Heading mr="10px">{isNew ? 'Создание документа' : 'Обновление документа'}</Heading>
              <Text color="orange.400">Версия: {item.version || ' - '}</Text>
              {!isNew && !item.removed && item.style !== styleType.OFFERTA && (
                <Box ml="auto">
                  <Delete id={id} />
                </Box>
              )}
            </HeadingContainer>

            <DocumentForm
              item={item}
              loading={loading || createLoading || updateLoading}
              onSubmit={handleSubmit}
            />
          </ContentContainerColumn>
        </ContentContainer>
      </CardContainer>
    </Container>
  )
}
